// import searchReducer from './search'
// import userReducer from './user'
import tourReducer from './tour'
import filterReducer from './filter'
import categoriesReducer from './categories'
import { IAppState } from '../state'
import { IAppStoreAction } from '../actions';

export const setCookie: Function = (value: String) => {
	document.cookie =
		'$2y$12$48ZpBH2TJC2eU6jC3vZlqeFzvdzhlt7J3MpXJWXy2JltTWUz4.PlO' +
		JSON.stringify(value) +
		'; path=/; secure; samesite=strict'
}

export default (
	{ tour, filter, categories }: IAppState,
	action: React.ReducerAction<React.Reducer<any, IAppStoreAction>>,
) => {
	const state = {
		// user: userReducer(user, action),
		// search: searchReducer(search, action),
		tour: tourReducer(tour, action),
		filter: filterReducer(filter, action),
		categories: categoriesReducer(categories, action)
	}
	setCookie(state)

	return state
}
